import { apiClient } from "../../../lib";

export const forecastVarianceApi = {

    fetchScopeChangeStates: async (): Promise<any> => {
        const response = await apiClient.get("/programme/scope-change-stats");
        return response.data;
    },

    fetchScopeChange: async (): Promise<any> => {
        const response = await apiClient.get("/programme/scope-change");
        return response.data;
    },

};